require('./../assets/css/connect-global.less');
require('./../assets/js/connect-global.js');
require('./components/connect-about-content/connect-about-content.less');
require('./components/connect-about-content/connect-about-content.js');